import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Waiting from './Waiting';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';

import _ from 'lodash';
import * as yup from 'yup';

import { makeRequest, resetErrorMessage } from '../actions';

const ChangePassword = ({passwordOpen, setPasswordOpen}) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');
	
	const dispatch = useDispatch();
	const user = useSelector(state => state.user);
	const [submitted, setSubmitted] = useState(false);
	const request = useSelector(state => state.requests.password_reset_with_password);
	
	const [showPassword, setShowPassword] = useState(false);
	
	const [data, setData] = useState({
		old_password: '',
		password: '',
		confirm_password: '',
	})
	
	const [validator, setValidator] = useState({
		old_password: { error: false, message: '' },
		password: { error: false, message: '' },
		confirm_password: { error: false, message: '' },
	})
	
	const fields = {
		old_password: 'Old password',
		password: 'New password',
		confirm_password: 'Confirm new password',
	}
	
	const schema = yup.object().shape({
		old_password: yup.string().required('Please enter your old password'),
		password: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*[<>\\&]).{8,20}$/, {message: 'Password must be 8-20 characters long, must contain a mix of uppercase and lowercase letters and numbers, and must not include any of these characters: <>\\&'}),
		confirm_password: yup.string().oneOf([data.password],'Password does not match').required('This is a required field'),
	})
	
	const storeAndValidate = (key, value) => {
		setData({...data, [key]: value});
		
		schema.validateAt(key, {[key]: value})
		.then(val => {
			setValidator({...validator, [key]: {error: false, message: ''}})
		})
		.catch(err => {
			setValidator({...validator, [key]: {error: true, message: err.message}})
		})
	}
	
	const maybeSubmit = () => {
		schema.validate(data, {abortEarly: false})
		.then((value) => {
			const toSend =  _.pick(data, ['old_password', 'password']);
			toSend.member_no = user.member_no;
			
			dispatch(makeRequest('update_password_with_password', toSend));
			setSubmitted(true);
		})
		.catch((err) => {
			const copyV = _.cloneDeep(validator);
			_.each(err.inner, (e) => {
				copyV[e.path].error = true;
				copyV[e.path].message = e.message;
			});
			setValidator(copyV);
		});
	}
	
	const resetForm = (close) => {
		dispatch(resetErrorMessage());
		if(close){
			setPasswordOpen(false);
		}
		setSubmitted(false);
		setData(_.mapValues(data, d => {return ''}));
	}
	
	const SubmitResult = () => {
		if(request.submitting){
			return <DialogContent dividers>
				<Waiting
				message='Submitting your request. Please wait...'
				/>
				</DialogContent>
		} else if(submitted && request.updated){
			return <>
			<DialogContent dividers>
			<Typography variant='h6' component='h3' gutterBottom>Success</Typography>
			<Typography paragraph>Your password has been updated.</Typography>
			</DialogContent>
			<DialogActions>
	  <Button autoFocus variant='contained' onClick={() => resetForm(true)} color="primary">
		Close
	  </Button>
		</DialogActions>
			</>
		} else if(submitted && !request.updated) {
			return <>
			<DialogContent dividers>
			<Typography variant='h6' component='h3' gutterBottom>Error</Typography>
			<Typography paragraph>Password NOT updated.</Typography>
			<Typography paragraph>{request.message}</Typography>
			</DialogContent>
			<DialogActions>
			<Button autoFocus onClick={() => resetForm(true)} color="primary">
		Close
	  </Button>
	  <Button autoFocus variant='contained' onClick={() => resetForm(false)} color="primary">
		Reset Form
	  </Button>
			</DialogActions>
			</>;
		} else {
			return <DialogContent dividers></DialogContent>
		}
	}
	
	return (
	<Dialog
		open={passwordOpen}
		onClose={() => resetForm(true)}
		fullScreen={!isSm}
		aria-labelledby="setings-dialog-title"
		className={classes.settingsDialog}
		>
		<DialogTitle id="settting-dialog-title">Change Password</DialogTitle>
		{submitted ? <SubmitResult /> :
		<>
		<DialogContent dividers>
		<form className={classes.form} autoComplete="off" noValidate> 
		<Grid container spacing={2}>
		
	{ _.map(data, (d, k) => (
		<Grid item key={k} xs={12}>
		<TextField
			variant="outlined"
			fullWidth
			error={validator[k].error}
			helperText={validator[k].message}
			type={showPassword ? "text" : "password"}
			autoComplete="new-password"
			InputProps={{
				endAdornment: (
				  <InputAdornment position="end">
					<IconButton
					  aria-label="toggle password visibility"
					  onClick={() => setShowPassword(!showPassword)}
					  onMouseDown={(event) => event.preventDefault()}
					  edge="end"
					>
					  {showPassword ? <Visibility /> : <VisibilityOff />}
					</IconButton>
				  </InputAdornment>
				)
			}}
			onChange={(event) => storeAndValidate(k, event.target.value)}
			label={fields[k]}
		/>
		</Grid>
	))}
	</Grid>
	</form>
	</DialogContent>
		<DialogActions>
	  <Button autoFocus onClick={() => resetForm(true)} color="primary">
		Cancel
	  </Button>
	  <Button variant='contained' onClick={() => maybeSubmit()} color="primary" autoFocus>
		Submit
	  </Button>
		</DialogActions>
		</>
		}
	</Dialog>
)}

export default ChangePassword;